import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommitteeMeetingSearchDto } from 'src/app/committees/shared/dto/committee-meeting-search.dto';

@Component({
  selector: 'wl-committee-meetings-search-params',
  templateUrl: './committee-meetings-search-params.component.html',
  styleUrls: ['./committee-meetings-search-params.component.less'],
    standalone: false
})
export class CommitteeMeetingsSearchParamsComponent implements OnInit {
  @Input()
  get searchParams() {
    return this._searchParams;
  }
  set searchParams(value: CommitteeMeetingSearchDto) {
    this._searchParams = value;
    this.searchParamsChange.emit(this._searchParams);
  }
  @Output() searchParamsChange: EventEmitter<CommitteeMeetingSearchDto> = new EventEmitter();

  private _searchParams: CommitteeMeetingSearchDto;

  constructor() {
    this.searchParams = new CommitteeMeetingSearchDto();
  }

  ngOnInit(): void {}
}
